export type SseEvent = {
  event: string;
  data: string;
};

export type SseParser = {
  push(chunk: string): void;
  flush(): void;
};

export function createSseParser(onEvent: (event: SseEvent) => void): SseParser {
  let buffer = "";

  function emit(rawEvent: string): void {
    const lines = rawEvent.split(/\r?\n/);
    let event = "message";
    const data: string[] = [];

    for (const line of lines) {
      if (line.startsWith("event:")) {
        event = line.slice("event:".length).trim();
      } else if (line.startsWith("data:")) {
        data.push(line.slice("data:".length).trimStart());
      }
    }

    if (data.length > 0) {
      onEvent({ event, data: data.join("\n") });
    }
  }

  function drain(): void {
    let boundary = buffer.search(/\r?\n\r?\n/);
    while (boundary >= 0) {
      const rawEvent = buffer.slice(0, boundary);
      const boundaryMatch = buffer.match(/\r?\n\r?\n/);
      const boundaryLength = boundaryMatch?.[0].length ?? 2;
      buffer = buffer.slice(boundary + boundaryLength);
      emit(rawEvent);
      boundary = buffer.search(/\r?\n\r?\n/);
    }
  }

  return {
    push(chunk: string): void {
      buffer += chunk;
      drain();
    },
    flush(): void {
      if (buffer.trim().length > 0) {
        emit(buffer);
      }
      buffer = "";
    },
  };
}
